
import LabelTypeList from './list.vue'
import LabelTypeEdit from "./edit.vue";

let a = Object.assign({LabelTypeList,LabelTypeEdit});
export default a;